import React from 'react';
import './InfoBlocks.css';
import fullkit from './assets/fullkit.png';
import { FaShieldAlt, FaDiscord, FaShoppingCart } from 'react-icons/fa';
import { RiGitRepositoryPrivateFill } from "react-icons/ri";
import { VscCompassActive } from "react-icons/vsc";
import { GiWingfoot, GiAk47 } from "react-icons/gi";
import { HiOutlineSquaresPlus } from "react-icons/hi2";
import { BsNvidia } from "react-icons/bs";
import { useTranslation } from 'react-i18next';

const InfoBlocks = () => {
  const { t } = useTranslation();

  return (
    <div className="info-blocks-wrapper">
      <h2 className="info-blocks-heading">{t('info_blocks_heading')}</h2>
      <p className="features-header-text">{t('features_header_text')}</p>

      {/* Erste Zeile */}
      <div className="info-blocks-container">
        <div className="info-block">
          <h3><FaShieldAlt className="info-icon" /> {t('undetected')}</h3>
          <p>{t('undetected_desc')}</p>
        </div>
        <div className="info-block">
          <h3><RiGitRepositoryPrivateFill className="info-icon" /> {t('private_builds')}</h3>
          <p>{t('private_builds_desc')}</p>
        </div>
        <div className="info-block">
          <h3><HiOutlineSquaresPlus className="info-icon" /> {t('hotkeys')}</h3>
          <p>{t('hotkeys_desc')}</p>
        </div>
      </div>

      {/* Zweite Zeile */}
      <div className="info-blocks-container second-row">
        <div className="info-block">
          <h3><GiAk47 className="info-icon" /> {t('all_weapons')}</h3>
          <p>{t('all_weapons_desc')}</p>
        </div>
        <div className="info-block">
          <h3><BsNvidia className="info-icon" /> {t('cloud_gaming')}</h3>
          <p>{t('cloud_gaming_desc')}</p>
        </div>
        <div className="info-block">
          <h3><GiWingfoot className="info-icon" /> {t('anti_afk')}</h3>
          <p>{t('anti_afk_desc')}</p>
        </div>
      </div>

      {/* Dritte Zeile */}
      <div className="info-blocks-container second-row">
        <div className="info-block">
          <h3><VscCompassActive className="info-icon" /> {t('active_development')}</h3>
          <p>{t('active_development_desc')}</p>
        </div>
        <div className="info-block">
          <h3><FaDiscord className="info-icon" /> {t('discord_support')}</h3>
          <p>{t('discord_support_desc')}</p>
        </div>
      </div>

      {/* Purchase-Button */}
      <div className="purchase-button-container">
        <button
          className="purchase-button"
          onClick={() => { window.location.href = "#pricing"; }}
        >
          <FaShoppingCart className="purchase-icon" />
          <span>{t('purchase_to_download')}</span>
        </button>
      </div>

      {/* Hintergrundbild, außerhalb des Contents */}
      <img src={fullkit} alt="Rust Full Weapon Kit Background - All Supported Weapons" className="info-blocks-bg" loading="lazy" />
    </div>
  );
};

export default InfoBlocks;
